var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhoneSolid = function SvgIconPhoneSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.5 11.683v2.947c0 .438-.338.8-.775.831q-.546.039-.892.039C6.47 15.5.5 9.53.5 2.167q0-.345.039-.892A.833.833 0 0 1 1.369.5h2.948c.214 0 .393.162.414.375q.03.286.054.46a11.6 11.6 0 0 0 1.006 3.334.38.38 0 0 1-.123.473L3.87 6.426a10.87 10.87 0 0 0 5.704 5.704l1.282-1.795a.385.385 0 0 1 .478-.124 11.6 11.6 0 0 0 3.334 1.004q.172.026.457.054c.213.021.375.2.375.414"
  })));
};
export default SvgIconPhoneSolid;